import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fm-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class NotFoundComponent {}
